<template>
  <div class="px-5 py-5">
    <notifications position="top center" ></notifications>

    <div class="flex flex-col center-content mb-7">
      <h2 class="font-bold text-center mb-5">Profile Settings</h2>
    </div>

    <div class="space-y-5">
      <div>
        <label for="name" class="block text-sm font-medium text-gray-700">
          Name <sup class="text-red required">*</sup>
        </label>
        <div class="mt-1">
          <input placeholder="Name" type="text"  v-model="form.name" id="name" autocomplete="" class="w-full sm:w-1/2 block sm:text-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500">
        </div>
      </div>

      <div>
        <label for="email" class="block text-sm font-medium text-gray-700">
          Email <sup class="text-red required">*</sup>
        </label>
        <div class="mt-1">
          <input placeholder="Email" type="text" v-model="form.email" id="email" autocomplete="" class="w-full sm:w-1/2 block sm:text-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500">
        </div>
      </div>

      <div>
        <label for="email" class="block text-sm font-medium text-gray-700">
          Update Password
        </label>
        <div class="mt-1 sm:mt-0 sm:col-span-2">
          <select v-model="this.change_password" id="change_password" name="change_password" autocomplete="" class="w-full sm:w-1/2 block sm:text-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500">
            <option value="no">No</option>
            <option value="yes">Yes</option>
          </select>
        </div>
      </div>


      <!--
      <div v-show="this.change_password == 'yes'">
        <label for="currentPassword" class="block text-sm font-medium text-gray-700">
          Current password
        </label>
        <div class="mt-1">
          <input placeholder="Current password" type="password" v-model="form.current_password" id="currentPassword" autocomplete="" class="w-full sm:w-1/2 block sm:text-sm">
        </div>
      </div>
      -->

      <div v-show="this.change_password == 'yes'">
        <label for="password" class="block text-sm font-medium text-gray-700">
          Password
        </label>
        <div class="mt-1">
          <input placeholder="Password" type="password" v-model="form.password" id="password" autocomplete="" class="w-full sm:w-1/2 block sm:text-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500">
        </div>
      </div>

      <div v-show="this.change_password == 'yes'">
        <label for="confirmPassword" class="block text-sm font-medium text-gray-700">
          Confirm password
        </label>
        <div class="mt-1">
          <input placeholder="Confirm password" type="password" v-model="form.password_confirmation" id="confirmPassword" autocomplete="" class="w-full sm:w-1/2 block sm:text-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500">
        </div>
      </div>

      <div>
        <legend class="text-base font-medium text-gray-900">Notification Preferences</legend>
        <div class="mt-4 space-y-4">
          <div class="flex items-start">
            <div class="flex items-center h-5">
              <input id="singleDonationNotification" v-model="form.single_donation_notification" type="checkbox" class="focus:ring-0 h-4 w-4 text-pink border-gray-300 rounded">
            </div>
            <div class="ml-3 text-sm">
              <label for="singleDonationNotification" class="text-gray-700">Single Donation Notification</label>
            </div>
          </div>
          <div class="flex items-start">
            <div class="flex items-center h-5">
              <input id="supportingCampaignNotification" v-model="form.supporting_campaign_notification" type="checkbox" class="focus:ring-0 h-4 w-4 text-pink border-gray-300 rounded">
            </div>
            <div class="ml-3 text-sm">
              <label for="supportingCampaignNotification" class="text-gray-700">Supporting Campaign Notification</label>
            </div>
          </div>
          <div class="flex items-start">
            <div class="flex items-center h-5">
              <input id="weeklyDigestNotification" v-model="form.weekly_digest_of_campaign_activity" type="checkbox" class="focus:ring-0 h-4 w-4 text-pink border-gray-300 rounded">
            </div>
            <div class="ml-3 text-sm">
              <label for="weeklyDigestNotification" class="text-gray-700">Weekly Digest of Campaign Activity</label>
            </div>
          </div>
        </div>
      </div>

      <button @click.prevent="updatedProfile"  class="inline text-center text-sm uppercase px-6 py-3 border border-transparent font-medium shadow-sm text-white bg-pink-500 hover:bg-pink-700 focus:outline-none  focus:ring-offset-2 focus:ring-pink-500">Update</button>
    </div>

  </div>

</template>

<script>
  export default {
    name: 'profile-form',
    props: ['authUser'],
    data() {
      return {
        change_password: 'no',
        form: {
          //current_password: '',
          password: '',
          password_confirmation: '',
          single_donation_notification: this.authUser.preferences ? this.authUser.preferences.single_donation_notification : null,
          supporting_campaign_notification: this.authUser.preferences ? this.authUser.preferences.supporting_campaign_notification : null,
          weekly_digest_of_campaign_activity: this.authUser.preferences ? this.authUser.preferences.weekly_digest_of_campaign_activity : null,
          name: this.authUser.name,
          email: this.authUser.email,
        },
      }
    },

    methods: {
      updatedProfile() {

        if (!this.form.name) {
          this.$notify({
            text: 'Name is required',
            type: 'error',
          })
          return
        }

        if (!this.form.email) {
          this.$notify({
            text: 'Email is required',
            type: 'error',
          })
          return
        }

        /*
        if (this.change_password == 'yes' && !this.form.current_password) {
          this.$notify({
            text: 'Current Password is required',
            type: 'error',
          })
          return
        }
        */

        if (this.change_password == 'yes' && !this.form.password ) {
          this.$notify({
            text: 'Password is required',
            type: 'error',
          })
          return
        }
        if (this.change_password == 'yes' && !this.form.password_confirmation) {
          this.$notify({
            text: 'Password Confirmation is required',
            type: 'error',
          })
          return
        }

        if (this.change_password == 'yes' && this.form.password !== this.form.password_confirmation) {
          this.$notify({
            text: 'Password does not match',
            type: 'error',
          })
          return
        }

        let payload = {
          name: this.form.name,
          email: this.form.email,
          change_password: this.change_password,
          single_donation_notification: this.form.single_donation_notification,
          supporting_campaign_notification: this.form.supporting_campaign_notification,
          weekly_digest_of_campaign_activity: this.form.weekly_digest_of_campaign_activity,
        }
        
        // Only include password fields if changing password
        if (this.change_password === 'yes') {
          payload.password = this.form.password;
          payload.password_confirmation = this.form.password_confirmation;
        }

        axios.post(`/profile-contact-update`, payload)
            .then((response) => {
              this.$notify({
                type: 'success',
                text: 'Profile successfully updated.',
              })
            })
            .catch((response) => {
              console.log(response)
              this.$notify({
                type: 'error',
                text: 'Error occurred. Please make sure email is valid, and new password matches.',
              })
            })
      },

    },
  }
</script>
